import { callApiToServer } from "../callApi";

export async function deleteSubCategory(authtoken, subCategoryId) {
  console.log(subCategoryId);
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify({
      "SubCategory_id": subCategoryId
    });


    let endUrl = "v1/auth/admin/delete-sub-category";

    console.log("endUrl printed here", endUrl);

    let responseData = await callApiToServer(body, header, "DELETE", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
